import { useCallback, useEffect, useRef, useState } from 'react';

import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { getActiveChannel } from '@/store/slices/user/selectors';
import { loadSeriesListForChannel } from '@/store/slices/series';

type TUseLoadChannelProjectCategories = {
  pageSize?: number;
  withEvents?: boolean;
  searchTerm?: string;
  enabled?: boolean;
};

const useLoadChannelSeries = (props?: TUseLoadChannelProjectCategories) => {
  const channel = useAppSelector(getActiveChannel);
  const enabled = props?.enabled ?? true;
  const dispatch = useAppDispatch();
  const [params, setParams] = useState({
    withEvents: props?.withEvents,
    limit: props?.pageSize || 1000,
    search: props?.searchTerm,
    page: 1,
  });
  const changeDebounce = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    // props change, reset page to 1
    setParams({
      withEvents: props?.withEvents,
      limit: props?.pageSize || 1000,
      search: props?.searchTerm,
      page: 1,
    });
  }, [props?.searchTerm, props?.pageSize, props?.withEvents]);

  useEffect(() => {
    if (channel && enabled) {
      if (changeDebounce.current) {
        clearTimeout(changeDebounce.current);
      }
      changeDebounce.current = setTimeout(() => {
        dispatch(
          loadSeriesListForChannel({
            ...params,
            channel,
          })
        );
      }, 500);
    }
  }, [dispatch, params, channel, enabled]);

  const loadMore = useCallback((page: number) => {
    setParams((prev) => ({ ...prev, page }));
  }, []);

  return { loadMore, page: params.page };
};

export default useLoadChannelSeries;
